import React from 'react';
import { visit } from 'unist-util-visit';
const Cite = require('citation-js');


// All functions expect tags like this:
// <cite a='author23text, author24text'>some text</cite>

function parseCitationString( string ) {
  // Example input: "wulff23research, peters281Test,some98moretest"
  // Output: ["wulff23research", "peters281Test", "some98moretest"]
  // the comma , matches a literal comma character, and the \s* matches zero or more whitespace characters.
  return string.split(/[,;]\s*/);
};


export const addCiteIndex = () => (tree) => {
  // Add a per-node property 'indexes' to the given node tree with unique per-citation indexes.
  // Can be unsorted, e.g. [2,1,3].
  let uniqueCitationsDict = {};
  let index = 0;

  visit(tree, 'element', (node, _, parent) => {
    let nodeIndexes = [];
    // If the element is a <cite> element and has valid authors
    if (node.tagName === 'cite' && node.properties.a != undefined) {
      // For every author in this citation
      for (const author of parseCitationString(node.properties.a)) {
        // Check if an index has not been assigned
        if ( !(author in uniqueCitationsDict) ) {
          index++;
          uniqueCitationsDict[author] = index;
        }
        // Add the authors-index pair to this citation
        nodeIndexes.push(uniqueCitationsDict[author]);
      }
      // Set element property
      node.properties.indexes = nodeIndexes;
    };
  });
};


export async function makeCitationsDict(bibtexFile) {
  try {
    const response = await fetch(bibtexFile);
    const bibtex = await response.text();
    const citationStrings = bibtex.split(/\n\n+/);
    const citationsDict = {};

    for (let i = 0; i < citationStrings.length; i++) {
      let citation = citationStrings[i];
      // console.log(citation);
      citation = new Cite(citation);
      const mlaCitation = citation.format('bibliography', {
        format: 'html',
        template: 'mla',
        lang: 'en-US'
      });
      citationsDict[citation.data[0].id] = mlaCitation;
    }
    return citationsDict;
  } catch (error) {
    // Handle error if fetch or other async operations fail
    console.error('ERROR DURING PARSING OF A BIBTEX FILE.');
    throw error;
  }
}


const Citation = ( {children, node, bibtexDict} ) => {

  let authors = node.properties.a;
  let indexes = node.properties.indexes;
  let citationStrings = []

  const sortAuthorsByIndex = () => {
    // Sorts two lists jointly by ascending order in numList
    //1) combine the arrays:
    var list = [];
    for (var j = 0; j < indexes.length; j++) 
        list.push({'index': indexes[j], 'author': authors[j]});
    //2) sort:
    list.sort(function(a, b) {
        return ((a["index"] < b["index"]) ? -1 : ((a["index"] == b["index"]) ? 0 : 1));
    });
    //3) return separate lists:
    indexes = list.map(item => item["index"]);
    authors = list.map(item => item["author"]);
    citationStrings = list.map(item => bibtexDict[item["author"]]);
  };

  // Preprocess the authors and indexes before rendering
  if ( node.properties.indexes != undefined) {
    if ( typeof authors === 'string' || authors instanceof String ) {
      authors = parseCitationString(authors);
      sortAuthorsByIndex();
    }
  };

  return (
    <span>
      {children}
      { (authors != undefined && indexes != undefined) ? (
        <sup className='text-theme-orange dark:text-theme-turquoise group'>
          <span className='font-bold'>[{ indexes.join(", ") }]</span>
          <div 
            className="absolute top-6 border-2 rounded border-theme-orange dark:border-theme-turquoise bg-light dark:bg-dark-accent bg-opacity-50 backdrop-blur-md invisible group-hover:visible hover:visible ease-out duration-200 z-50"
            // The text is 576px wide on desktop and has 2*20px margins on mobile.
            style={{width: `${Math.min(576, window.innerWidth - 40)}px`}}
          >
            <span className='flex flex-col text-xs md:text-sm m-2'>
              <span className='font-bold'>Citation</span>
              <span className='text-dark-accent dark:text-light-accent'>
                {
                  indexes.map((citeIdx, idx) => <span 
                    key={idx} 
                    className='flex'
                  >
                    <span className='mr-2'>[{citeIdx}]</span>
                    <span dangerouslySetInnerHTML={{__html: citationStrings[idx]}}/>
                  </span>
                )}
              </span>
            </span>
          </div>
        </sup>
      ) : null 
      }
    </span>
  )
};

export default Citation;